// import jwt from 'jsonwebtoken'
import {
  apiHost
} from '@/config/routes'
import axios from 'axios'
import store from '@/stores/store'

const jwtService = {}

jwtService.validateToken = async () => {
  try {
    const request = {
      method: 'GET',
      url: apiHost + '/channel/api/auth/validate-token/',
    }
    const response = await axios(request)
    if (!response.data) return false
    if (response.data?.message == 'Token valido') {
      return true
    } else {
      return false
    }
  } catch (err) {
    if (err.response && err.response.status === 401) return false
  }
  return new Error('Error de conexión')
}

jwtService.refreshToken = async () => {
  try {
    const request = {
      method: 'GET',
      url: apiHost + '/channel/api/auth/refresh-token',
    }
    const response = await axios(request)
    if (!response.data) return false
    let accessToken = response.data?.data?.token
    if (accessToken) {
      // change Token in localStorage
      store.dispatch('refreshToken', accessToken)
      return accessToken
    }
  } catch (err) {
    console.log(err)
    if (err.response && err.response.status === 401) return false
  }
  return new Error('Error de conexión')
}
export default jwtService